/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_USER_URL, COMMON_HEADER_CONFIG} from "src/config";
import {TOKEN_DUMMY} from "src/constants";

class UserService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getUsers = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/users`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneUser = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/user/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createUser = (data) =>
    new Promise((resolve, reject) => {
      const formattedData = data;
      if ("email" in formattedData) {
        formattedData.email = formattedData.email.toLowerCase();
      }
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_USER_URL}/user`,
        data: dataCreate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateUser = (data) =>
    new Promise((resolve, reject) => {
      const formattedData = data;
      if ("email" in formattedData) {
        formattedData.email = formattedData.email.toLowerCase();
      }
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "put",
        url: `${API_USER_URL}/user/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateRoleOfUser = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_USER_URL}/user/roles`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePermissionOfUser = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_USER_URL}/user/permissions`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateActiveUser = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify({
        ...data,
        active: !data.active
      });
      const config = {
        method: "put",
        url: `${API_USER_URL}/user/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteUser = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_USER_URL}/user/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getUsersByPermission = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/users/get-users-from-permission`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-token-dummy": TOKEN_DUMMY
        },
        params: {...params}
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  changeUserLanguage = (lang, fcmToken) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_USER_URL}/user/language`,
        data: {
          platform_name: "AP"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "x-api-language": lang,
          "x-device-token": fcmToken
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const userService = new UserService();

export default userService;
